module.exports = __webpack_public_path__ + "img/about-right.5ed2cdd2.png";